import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import Table from "../../../../components/table/coreUiTable/Table";
import { cuFormat, calculateTotals } from "../../../../components/table/coreUiTable/Format";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export const ReferralBreakdownTable = () => {
  const dispatch = useDispatch();

  const toggleReferralCategory = useSelector(
    (state) => state.laser.selectedFilters.toggleReferralCategory
  );
  const referralTableLoading = useSelector((state) => state.laser.referralTableLoading);
  const organization_name = useSelector(
    (state) => state.commonReducer.commonProps.organization_name
  );

  let { tableInfo: table } = useSelector((state) => state.laser.referralTable.referrals_table);

  const [filteredData, setFilteredData] = useState([]);
  const [totalWidths, setTotalWidths] = useState([]);
  const [col1Total, setCol1Total] = useState(0);

  const isRowHouse = organization_name === "Row House";
  const showTotals = table.data.length > 0;

  // we need reference to each thead.tr in table to their get widths
  const children = document.getElementById("referralBreakdown")?.querySelector("tr")?.children;

  const updateTotalRowWidth = () => {
    if (showTotals) {
      // if rendered get children's widths on each filter (render)
      if (children) {
        const newtWidths = [];
        for (let i = 0; i < children.length; i++) {
          newtWidths.push(children[i].offsetWidth);
        }

        setTotalWidths(newtWidths.splice(1));
      }

      // if Row House recalculate second column on each filter (render)
      if (isRowHouse) {
        setCol1Total(
          filteredData.map((row) => row[table.colHeaders[1]]).reduce((acc, res) => acc + res, 0)
        );
      }
    }
  };

  useEffect(() => {
    updateTotalRowWidth();
  }, [filteredData]);

  //TODO: remove this workaround when backend will send proper data on Row House
  if (isRowHouse && showTotals) {
    table = {
      ...table,
      data: table.data.map((row) => {
        row[2] = row[1] / col1Total;
        return row;
      })
    };
  }

  // Format all values according to columns array
  const formattedSlots = cuFormat({
    headers: table.colHeaders,
    // TODO: ask backend to change api accordingly in order to avoid workaround
    columns: table.columns.map((col) =>
      col.numericFormat ? { ...col, format: col.numericFormat.pattern } : col
    ),
    links: table.links
  });

  const changeTotalRowWidth = () => {
    setTimeout(() => updateTotalRowWidth(), 0);
  };

  return (
    <>
      <div className="select-box toggle" style={{ width: 203 }}>
        <p className="offers-title">Referral Category</p>
        <ToggleableButton
          isRadio
          title="referral-category"
          isActive={toggleReferralCategory}
          onClick={(val) => dispatch(actionCreators.toggleReferralCategory(val))}
        />
      </div>
      {referralTableLoading ? (
        <LoadingAnimation />
      ) : (
        <Table
          tableWrapperId="referralBreakdown"
          table={table}
          sorter
          scopedSlots={formattedSlots}
          onFilteredItemsChange={(data) => setFilteredData(data)}
          onPageChange={changeTotalRowWidth}
          underTableSlot={
            showTotals ? (
              <table className="table coreUiTable" id="under-table-slot">
                <tbody>
                  <tr className="">
                    <td style={{ fontWeight: "700" }}>Total</td>
                    {/*Using formattedSlots to get formats for totals as well*/}
                    {table.colHeaders.slice(1).map((header, index) => {
                      // formattedSlots is an object with header names as properties
                      // and callback render functions as values, thus formattedSlots[header]
                      // is a function which may receive two arguments 'function(value, tdStyles)'.
                      // Code below basically returns '<td styles={{...tdStyles}}>{formatted(value)}</td>'.
                      const renderFunc = formattedSlots[header];

                      // style for current column tds
                      const tdStyle = { width: `${totalWidths[index]}px` };

                      // raw value for totals row after performing calculations
                      const value = {
                        [header]: calculateTotals(
                          filteredData,
                          table.rowCalculations[index + 1],
                          table.colHeaders,
                          header
                        )
                      };

                      return renderFunc(value, tdStyle);
                    })}
                  </tr>
                </tbody>
              </table>
            ) : null
          }
        />
      )}
    </>
  );
};
